import {
  getEntityTypeFromEntityId,
  getSimpleEntityDisplayNameFromId,
  isComplexEntityType,
} from "../../../../../../utils/utils";

export const mergeEntitiesByType = (target, ...sources) => {
  const merged = { ...target };

  sources.forEach((source) => {
    Object.entries(source).forEach(([type, entities]) => {
      merged[type] = [...(merged[type] || []), ...entities];
    });
  });

  return merged;
};

export const createFallbackSimpleEntitiesFromComplexIds = (
  entityIds,
  complexEntitiesByType,
  controlId,
  trackEvent,
  trackingMessage = "entities not found in DB"
) => {
  // When complex entities (hosts, users, etc.) are missing from the DB response,
  // this function converts them to simple entities displaying just the entity ID.

  const fallbackEntitiesByType = {};
  let fallbackCount = 0;

  entityIds?.forEach((entityId) => {
    const entityType = getEntityTypeFromEntityId(entityId);

    if (!isComplexEntityType(entityType)) return;

    const entityExistsInComplexData = complexEntitiesByType?.[entityType]?.some(
      (entity) => entity.entity_id === entityId
    );

    if (!entityExistsInComplexData) {
      if (!fallbackEntitiesByType[entityType]) {
        fallbackEntitiesByType[entityType] = [];
      }
      fallbackEntitiesByType[entityType].push({
        entity_id: entityId,
        display_name: getSimpleEntityDisplayNameFromId(entityId),
        entity_type: entityType,
      });
      fallbackCount++;
    }
  });

  if (fallbackCount > 0 && trackEvent) {
    trackEvent(
      `Fallback to simple entities for control ${controlId}: ${fallbackCount} ${trackingMessage}`
    );
  }

  return fallbackEntitiesByType;
};
